import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'image'
})
export class ImagePipe implements PipeTransform {

  transform(value: string, size: 'large' | 'medium' | 'small' | 'tiny'): any {
    const valueArray = value.split('.');

    valueArray.forEach((item, key) => {
      if (key + 1 === valueArray.length - 1) {
        valueArray[key] += '_' + size;
      }
    });

    return valueArray.join('.');
  }

}
